module.exports = __webpack_public_path__ + "static/media/times-hexagon.28cbd121.svg";